import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useQuery } from "@apollo/client";
import usePageTitle from "@/hooks/usePageTitle";
import useCapabilities, { useDenyAuthorization } from "@/hooks/useCapabilities";
import { ROLE } from "@/providers/AuthorizationProvider/types";
import { UNIVERSITY_QUERY } from "../queries";
import { UniversityStaffTable } from "./_UniversityStaffTable";

export default function UniversityStaffPage() {
  const { universityId } = useParams();
  const { loaded, hasRole } = useCapabilities();
  const denyAuthorization = useDenyAuthorization();
  const canManageUniversityStaff = hasRole(ROLE.EDUCATION_ADMIN) || hasRole(ROLE.GLOBAL_ADMIN);

  usePageTitle(`/education/universities/${universityId}/staff`, "Education | University Staff");

  useEffect(() => {
    if (loaded && !canManageUniversityStaff) {
      denyAuthorization();
    }
  }, [loaded, canManageUniversityStaff, denyAuthorization]);

  const { data: universityData } = useQuery(UNIVERSITY_QUERY, {
    variables: { legacyId: universityId },
    skip: !universityId
  });

  const university = universityData?.universities[0];

  if (!universityId || !canManageUniversityStaff) {
    return null;
  }

  return <UniversityStaffTable universityLegacyId={universityId} universityName={university?.name || ""} />;
}
